import { useEffect, useState } from 'react';

export function useVisualViewportHeight() {
	const [height, setHeight] = useState<number | null>(null);

	useEffect(() => {
		if (!window.visualViewport) return;

		const update = () => {
			setHeight(window.visualViewport!.height);
		};

		update();
		window.visualViewport.addEventListener('resize', update);

		return () => {
			window.visualViewport?.removeEventListener('resize', update);
		};
	}, []);

	return height;
}
